const partnersCategories = [
	{
		path: '/network/partners-categories/list',
		name: 'network-partners-categories-list',
		component: () => import('@/views/network/partners-categories/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,partners',
		},
	},
]

export default partnersCategories
